import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "./need.module.scss"
import Markdown from "react-markdown"

const BotanicalNeed = props => {
  const data = props.data.strapiBotanicalReset

  return (
    <div id="payment-anchor">
      <div className={styles.need}>
        <Container>
          <div
            className={`${styles.need__wrap} d-flex align-items-center justify-content-between`}
          >
            <div className={styles.need__content}>
              <h2>{data.NeedSection.Heading}</h2>
              <Markdown>{data.NeedSection.Body}</Markdown>
            </div>
            <div
              className={`${styles.need__boxes} d-flex align-items-center justify-content-between`}
            >
              {data.NeedBoxes.map((box, key) => (
                <div className={styles.need__boxes__box} key={key}>
                  <img src={box.Image.publicURL} alt={box.Text} />
                  <p>{box.Text}</p>
                  <a target="_blank" href={box.ButtonLink} className="cta">
                    {box.ButtonText}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default BotanicalNeed
